
export default function CTA() {
  return (
    <section id="contact" className="py-32 bg-white">
      <div className="max-w-4xl mx-auto px-8 text-center">
        <h2 className="font-bold text-5xl text-[#2a2a2a] mb-6">
          Ready to Build Your Dream Beauty Store?
        </h2>

        <p className="text-gray-600 text-xl font-light mb-10">
          Partner with Mount Zion Investment INC and launch a retail store that stands out
        </p>

        <button className="bg-rose-500 text-white px-14 py-4 rounded-full text-base font-medium hover:bg-rose-600 transition-all inline-flex items-center gap-3 whitespace-nowrap cursor-pointer group mx-auto">
          Start Building With Us
          <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
        </button>

        <div className="mt-20 flex items-center justify-center gap-12">
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center mb-2">
              <i className="ri-store-3-line text-4xl text-rose-400"></i>
            </div>
            <p className="text-sm text-gray-600">50+ Stores Built</p>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center mb-2">
              <i className="ri-leaf-line text-4xl text-rose-400"></i>
            </div>
            <p className="text-sm text-gray-600">Sustainable Design</p>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center mb-2">
              <i className="ri-star-line text-4xl text-rose-400"></i>
            </div>
            <p className="text-sm text-gray-600">5-Star Rated</p>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center mb-2">
              <i className="ri-team-line text-4xl text-rose-400"></i>
            </div>
            <p className="text-sm text-gray-600">Expert Retail Team</p>
          </div>
        </div>
      </div>
    </section>
  );
}
